import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[dialogContentHeader]',
})
export class DialogContentHeader {
  constructor(public templateRef: TemplateRef<any>) {}
}